module.exports = "<div class=\"dialog-contents\">\n  <h2 class=\"\">Olet kirjautunut ulos. Kirjaudu sisään jatkaakses</h2>\n    <div class=\"ngdialog-buttons\">\n      <button type=\"button\" class=\"btn btn-default ngdialog-button confirm\" ng-click=\"confirm()\">Kirjaudu</button>\n      <button type=\"button\" class=\"btn btn-default ngdialog-button close-dialog\" ng-click=\"closeThisDialog()\">Peruuta</button>\n    </div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./bidding_product/template/modal_notify.html
 ** module id = 53
 ** module chunks = 0
 **/